import { render } from "./CertAlcoholPendingReview.vue?vue&type=template&id=bfb125d4&scoped=true"
import script from "./CertAlcoholPendingReview.vue?vue&type=script&lang=js"
export * from "./CertAlcoholPendingReview.vue?vue&type=script&lang=js"

import "./CertAlcoholPendingReview.vue?vue&type=style&index=0&id=bfb125d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb125d4"]])

export default __exports__